import { MainCategoryResult as TMainCategoryResult } from "@/schema/improvement-proposal/MainCategoryResult";
import SubCategoryResult from "@/src/_components/ImprovementProposalResult/SubCategoryResult";
import { TextBulletListSquare24Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

interface MainCategoryResultProps {
  mainCategoryResult: TMainCategoryResult;
}
export default function MainCategoryResult({
  mainCategoryResult: { content, sub_category_results },
}: MainCategoryResultProps) {
  const { t } = useTranslation();
  return (
    <div className="pdf-component">
      <div className="bg-cool-gray-100 flex flex-row items-center gap-x-[12px] px-[12px] py-[8px] border-t-[1px] border-cool-gray-200">
        <TextBulletListSquare24Regular />
        <span className="text-cool-gray-900 text-[14px] font-medium">
          {content}
        </span>
        <span className="text-cool-gray-500 text-[12px] font-medium ml-auto">
          {sub_category_results.length}{" "}
          {sub_category_results.length > 1
            ? t("sub-categories")
            : t("sub-category")}
        </span>
      </div>
      {sub_category_results.map((item, index) => (
        <SubCategoryResult
          key={item.id}
          isLast={index === sub_category_results.length - 1}
          subCategoryResult={item}
        />
      ))}
    </div>
  );
}
